const SCHOOL_LOGOS_LOADING = "SCHOOL_LOGOS_LOADING";
const SCHOOL_LOGOS_SUCCESS = "SCHOOL_LOGOS_SUCCESS";
const SCHOOL_LOGOS_ERROR = "SCHOOL_LOGOS_ERROR";

export {
    SCHOOL_LOGOS_LOADING,
    SCHOOL_LOGOS_ERROR,
    SCHOOL_LOGOS_SUCCESS,
};